import {importDynamicModulesList} from "@nextories/vue-core-components/src/utils/helpers/format";

const fields = import.meta.glob("./organisms/fields/*.vue", { eager: true });
const listActionEmail = import.meta.glob(
  "/node_modules/@nextories/vue-tasks/src/components/templates/project/NxtTasksListActionEmail.vue",
  { eager: true },
);

export default importDynamicModulesList([fields, listActionEmail]);
